import loader from "./loader";
import moment from "moment";
import secureStorage from "libs/secureStorage";
import getinfo from "helper/getinfo";

const receipt = (payload) => {
  const printer = secureStorage.getItem("printer");
  const user = secureStorage.getItem("account");
  const body = payload.body;
  const title = `${payload.title.padStart(105, " ")}\r\n`;

  const date =
    body.date && body.date.value ? body.date.value : payload.createdAt;

  const leftPage = [
    ["TGL", moment(date).format("DD/MM/YY HH:mm")],
    ["IDPEL", body.subscriberId.value],
    ["NAMA", body.name.value],
    ["GOL", body.tariffGroup.value],
    ["VOL", `${body.volume.value} M3`],
    ["BAYAR", body.total.value],
  ];

  for (let i = leftPage.length; i < 11; i++) leftPage.push([""]);

  const middlePage = [
    ["TANGGAL", moment(date).format("DD/MM/YY HH:mm")],
    ["IDPEL", body.subscriberId.value],
    ["NAMA", body.name.value],
    ["GOL", body.tariffGroup.value],
    ["VOLUME", `${body.volume.value} M3`],
    ["NO REF", body.referenceNo.value.toString().substring(0, 15)],
    ...getinfo(body.info.value),
  ];

  printer === "dotmatrix"
    ? middlePage.push([
        `${String.fromCharCode(27)}4Loket : ${user.name}${String.fromCharCode(
          27
        )}5`,
      ])
    : middlePage.push([`Loket : ${user.name}`]);
  // printer === "dotmatrix"
  //   ? middlePage.push([
  //       `Powered by ${payload.appName}${String.fromCharCode(27)}5`,
  //     ])
  //   : middlePage.push([`Powered by ${payload.appName}`]);

  for (let i = middlePage.length; i < 11; i++) middlePage.push([""]);

  const rightPage = [
    ["HRG GAS", body.gasPrice.value],
    ["NILAI GAS", body.gasAmount.value],
    ["PPN", body.ppn.value],
    ["MATERAI", body.stampDuty.value],
    // ["RP TAG", body.amount.value],
    ["ADMIN", body.admin.value],
    ["BAYAR", body.total.value],
  ];

  for (let i = rightPage.length; i < 11; i++) rightPage.push([""]);

  //   return loader(title, leftPage, middlePage, rightPage, payload);
  if (printer === "dotmatrix")
    return loader(title, leftPage, middlePage, rightPage, payload);
  else return { title, leftPage, middlePage, rightPage, payload };
};
export default receipt;
